import React from "react";
import styles from "./PeopleUI.module.css";

export default function SubsectionHeader({
  label,
  count,
  collapsed,
  onToggleCollapse,
}) {
  return (
    <div className={styles.subHeader}>
      <span className={styles.subHeaderLabel}>{label}</span>
      {typeof count === "number" && (
        <span className={styles.subHeaderCount}>· {count}</span>
      )}
      {onToggleCollapse && (
        <button
          type="button"
          className={`${styles.collapseChevron} ${styles.collapseChevronSmall} ${collapsed ? styles.collapseChevronCollapsed : ""}`}
          onClick={onToggleCollapse}
          aria-label={collapsed ? `Expand ${label}` : `Collapse ${label}`}
          aria-expanded={!collapsed}
        >
          ▾
        </button>
      )}
    </div>
  );
}
